import m from "../../geodata/es2015/nicaraguaLow";
window.am4geodata_nicaraguaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/nicaraguaLow.js
// module id = null
// module chunks = 